export const PATHS = {
  HOME: '/'
}